
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Component that scrolls to the top of the page when the route changes
 * and tracks page views for Google Analytics
 */
export function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
    
    // Track page view in Google Analytics
    trackPageView(pathname);
  }, [pathname]);
  
  return null;
}
